import "highlight.js/styles/monokai-sublime.css";

import hljs from "highlight.js";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    hljs: any;
  }
}

hljs.configure({
  languages: ["javascript", "jsx", "sh", "bash", "html", "scss", "css", "json"],
});

if (typeof window !== "undefined") {
  window.hljs = hljs;
}
